import { Typography } from 'antd';
import { TextProps } from 'antd/lib/typography/Text';
import TranslateText from 'components/hoc/TranslateText';
import React from 'react';

const Text = Typography.Text;

interface IParagraph extends TextProps {
    text: string;
}

const Paragraph: React.FC<IParagraph> = props => {
    return (
        <Text {...props} className={props.className || 'paragraph'}>
            <TranslateText>{props.text}</TranslateText>
        </Text>
    );
};

export default Paragraph;
